module.exports = __webpack_public_path__ + "static/media/phone-color.e3244472.png";